import { Stack } from '@mui/material';
import { MotionViewport } from 'src/components/animate';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import { Props } from 'src/features/@types/catalogo';
import WhatsAppPopup from 'src/features/components/whatsAppPopup';
import { StyledContainerPicture } from './styles';

// -----------------------------------------------------------------------------------

export default function Catalogo({ label, children }: Props) {
  return (
    <Stack component={MotionViewport}>
      <Stack ml={15} mt={5}>
        <CustomBreadcrumbs
          heading={`${label}`}
          links={[
            {
              name: 'Home',
              href: '/',
            },
            {
              name: label,
            },
          ]}
        />
      </Stack>

      <StyledContainerPicture>{children}</StyledContainerPicture>

      <WhatsAppPopup />
    </Stack>
  );
}
